import { env } from '@/constant/process';

const enableTracker = env.publicLocale !== 'zh-cn';

let cachedModule: any = null;

async function loadTracker() {
  if (!enableTracker) return null;

  if (cachedModule) return cachedModule;

  const mod = await import('@decodo/tracker');
  cachedModule = mod.default ?? mod;

  return cachedModule;
}

export function track(eventName: string, properties?: Record<string, any>) {
  if (!enableTracker) return;

  void loadTracker().then((t) => t.track(eventName, properties));
}

export async function getTrackerInstance() {
  return loadTracker();
}

const lazyTracker = {
  init: (...args: any[]) => {
    void loadTracker().then((t) => t?.init?.(...args));
  },
  track,
  getTrackerInstance,
};

export default lazyTracker;
